//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _willRemove_inventory_inventory from './willRemove_inventory_inventory';
export const willRemove_inventory_inventory = _willRemove_inventory_inventory;
export default {willRemove_inventory_inventory};

